import type { KanbanComment } from '@ts-kanban-comments/interfaces'

import { useKanbanCommentsStore } from '@stores/kanban-comments'
import { useCommonStore } from '@stores/common'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

interface CommentsApiOptions {
  tutorId: string | number
  onStart?: () => void
  onSuccess?: (data: KanbanComment[]) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useCommentsApi = async (options: CommentsApiOptions): Promise<KanbanComment[]> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.comments', { tutor_id: options.tutorId })

  const kanbanCommentsStore = useKanbanCommentsStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const comments: KanbanComment[] = data.data

    kanbanCommentsStore.setComments(comments)
    commonStore.setLoading(false)

    options.onSuccess?.(comments)

    return comments
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return []
  } finally {
    options.onFinish?.()
  }
}
